import { css, html } from "../helpers/webComponents";

const styleModal: string = css`
        .modal {
            background-color: #d9ba8b;
            border: 2px solid burlywood;
            color: black;
            border-radius: 5px;
            position: absolute;
            height: 50%;
            width: 50%;
            top: 0px;
            left: 0px;
            display: flex;
        }
    `;

export class KindComponent extends HTMLElement {
    private isOpen: boolean = false;

    /**
     * Create a new instance of the kind component
     *
     * @param alias Alias used to identify this action
     * @param name Name of this action
     * @param coordinates Coordinates of the action on the screen
     * @param size Size of the action on the screen
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        const element: HTMLElement = html`
        <div>
            <style>${styleModal}</style>
            <script src="/wwwroot/public/pong.js"></script>
            <div class="modal"></div>
        </div>
            `;

        this.shadowRoot.append(element);
    }

    public toggle(): void {
        this.isOpen = !this.isOpen;
        this.render();
    }
}
